import React from 'react';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { colors } from '@/styles/colors';

export interface DropdownHeaderSummaryProps {
  title: string;
  summary?: {
    amountSold?: number;
    totalSaleValue?: number;
    totalCommission?: number;
    courtesies?: number;
    discount?: number;
  };
  payments?: {
    credit?: number;
    debit?: number;
    pix?: number;
    money?: number;
  };
  customItemsCount?: number;
  customTotalValue?: number;
  customCommissionValue?: number;
  customCourtesiesCount?: number;
}

export const ReportDropdownHeader: React.FC<DropdownHeaderSummaryProps> = ({
  title,
  summary,
  payments,
  customItemsCount,
  customTotalValue,
  customCommissionValue,
  customCourtesiesCount,
}) => {
  const amountSold = customItemsCount ?? summary?.amountSold ?? 0;
  const courtesies = customCourtesiesCount ?? summary?.courtesies ?? 0;
  const totalSaleValue = customTotalValue ?? summary?.totalSaleValue ?? 0;
  const totalCommission = customCommissionValue ?? summary?.totalCommission ?? 0;
  const discount = summary?.discount ?? 0;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingRight: '16px',
      }}
    >
      <h6
        style={{
          fontWeight: 600,
          color: '#1b4880',
          fontSize: '15.5px',
          marginBottom: '10px',
          marginTop: 0,
        }}
      >
        {title}
      </h6>
      <div
        className="d-none d-sm-flex align-items-center flex-wrap"
        style={{ fontSize: '13px', color: '#495057' }}
      >
        {/* Vendas */}
        <div
          style={{
            marginRight: '12px',
            marginBottom: '4px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '6px',
            padding: '4px 10px',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <span style={{ color: '#6c757d', marginRight: '6px' }}>Vendas:</span>
          <strong style={{ color: '#212529', fontWeight: 600 }}>{amountSold}</strong>
        </div>

        {/* Cortesias */}
        {courtesies > 0 && (
          <div
            style={{
              marginRight: '12px',
              marginBottom: '4px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: '6px',
              padding: '4px 10px',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <span style={{ color: '#6c757d', marginRight: '6px' }}>Cortesias:</span>
            <strong style={{ color: '#212529', fontWeight: 600 }}>{courtesies}</strong>
          </div>
        )}

        {/* Descontos */}
        {discount > 0 && (
          <div
            style={{
              marginRight: '12px',
              marginBottom: '4px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: '6px',
              padding: '4px 10px',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <span style={{ color: '#6c757d', marginRight: '6px' }}>Descontos:</span>
            <strong style={{ color: '#212529', fontWeight: 600 }}>{toCurrency(discount)}</strong>
          </div>
        )}

        {/* Venda */}
        <div
          style={{
            marginRight: '12px',
            marginBottom: '4px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '6px',
            padding: '4px 10px',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <span style={{ color: '#6c757d', marginRight: '6px' }}>Venda:</span>
          <strong style={{ color: colors.lightBlue, fontWeight: 700 }}>
            {toCurrency(totalSaleValue)}
          </strong>
        </div>

        {/* Comissão */}
        {totalCommission > 0 && (
          <div
            style={{
              marginRight: '12px',
              marginBottom: '4px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: '6px',
              padding: '4px 10px',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <span style={{ color: '#6c757d', marginRight: '6px' }}>Comissão:</span>
            <strong style={{ color: '#212529', fontWeight: 600 }}>
              {toCurrency(totalCommission)}
            </strong>
          </div>
        )}

        {/* Pagamentos Separados em Chips */}
        {payments && (
          <React.Fragment>
            <div
              style={{
                marginRight: '12px',
                marginBottom: '4px',
                backgroundColor: '#ffffff',
                border: '1px solid #e9ecef',
                borderRadius: '6px',
                padding: '4px 10px',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <span style={{ color: '#6c757d', marginRight: '6px' }}>Crédito:</span>
              <strong style={{ color: '#343a40' }}>{toCurrency(payments.credit || 0)}</strong>
            </div>

            <div
              style={{
                marginRight: '12px',
                marginBottom: '4px',
                backgroundColor: '#ffffff',
                border: '1px solid #e9ecef',
                borderRadius: '6px',
                padding: '4px 10px',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <span style={{ color: '#6c757d', marginRight: '6px' }}>Débito:</span>
              <strong style={{ color: '#343a40' }}>{toCurrency(payments.debit || 0)}</strong>
            </div>

            <div
              style={{
                marginRight: '12px',
                marginBottom: '4px',
                backgroundColor: '#ffffff',
                border: '1px solid #e9ecef',
                borderRadius: '6px',
                padding: '4px 10px',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <span style={{ color: '#6c757d', marginRight: '6px' }}>Pix:</span>
              <strong style={{ color: '#343a40' }}>{toCurrency(payments.pix || 0)}</strong>
            </div>

            <div
              style={{
                marginRight: '12px',
                marginBottom: '4px',
                backgroundColor: '#ffffff',
                border: '1px solid #e9ecef',
                borderRadius: '6px',
                padding: '4px 10px',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <span style={{ color: '#6c757d', marginRight: '6px' }}>Dinheiro:</span>
              <strong style={{ color: '#343a40' }}>{toCurrency(payments.money || 0)}</strong>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
